import { useLayout } from '../../core'
import { DefaultTitle } from './page-title/DefaultTitle'
import { HeaderNotificationsMenu, ThemeModeSwitcher } from '../../../partials'
import { useAuth } from '../../../../app/modules/auth'
import { useMediaQuery } from 'react-responsive'
import { Dropdown, DropdownItem } from 'app/components'
import { useNavigate } from 'react-router-dom'
import { ContratoType, IconPaths, Permission } from '_metronic/helpers'
import { useBrand } from 'app/modules/brand-management/context/BrandContext'
import { useT } from '_metronic/i18n/Metronici18n'

export const HeaderToolbar = () => {
  const { classes } = useLayout()
  const { logout, currentUser } = useAuth()
  const navigate = useNavigate()
  const { currentBrand } = useBrand()
  const { t } = useT()

  const isMobile = useMediaQuery({ maxWidth: 767 })

  const handleNavigate = () => navigate('/configuracoes/tema')

  const showGerenciarLayout =
    currentUser?.grupo?.nome === Permission.SuperAdmin ||
    (!!currentBrand &&
      currentUser?.grupo?.nome === Permission.Admin &&
      currentUser?.vinculos?.some(
        (vinculo) =>
          vinculo.ativo &&
          vinculo.responsavel &&
          vinculo.empresa?.id === currentBrand.id &&
          vinculo.empresa?.tiposContrato?.includes(ContratoType.Layout)
      ))

  return (
    <div className='toolbar d-flex align-items-center'>
      <div
        className={`${classes.headerContainer.join(
          ' '
        )} py-6 py-lg-0 d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between`}
      >
        <DefaultTitle />
        <div className='d-flex align-items-center gap-2 pt-3 pt-lg-0'>
          <HeaderNotificationsMenu />
          <ThemeModeSwitcher />

          {!isMobile && (
            <Dropdown icon={IconPaths.Gear} variant='transparent'>
              {showGerenciarLayout && (
                <DropdownItem onClick={handleNavigate}>Gerenciar tema</DropdownItem>
              )}
              <DropdownItem onClick={() => navigate('/apps/novidades')}>
                {t('menu.novidades')}
              </DropdownItem>
              <DropdownItem onClick={logout}>Sair</DropdownItem>
            </Dropdown>
          )}
        </div>
      </div>
    </div>
  )
}
